export function setCookie(name, value, maxAgeSeconds, path) {
    const expirationDate = new Date(
        Date.now() + maxAgeSeconds * 1000
    );
    const cookieString = `${name}=${encodeURIComponent(
        value
    )}; expires=${expirationDate}; path=${path}`;

    document.cookie = cookieString;
}